'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // main
  black: '#333',
  gray7: '#777',
  gray9: '#999',
  grayB: '#b3b3b3',
  grayD: '#d1d1d1',
  grayE: '#eaeaea',
  grayF: '#f6f6f6',
  white: '#fff',
  red: '#e95175',

  // blandColor
  blue: '#4abfe6',
  green: '#60df52',
  stayPink: '#dc4d6f',

  // rental
  blueBdColor: '#42a9cc',
  subBgColor: '#e8f6fb',

  // stay
  stayPinkBdColor: '#b82346',
  stayLightPink: '#ee597c',

  // rental & dashboard & business
  greenBdColor: '#60ce52',
  lightgreen: '#eaf8e9',
  lightgreenBdColor: '#e4f2e3',

  primaryColors: {
    stay: '#dc4d6f',
    www: '#4abfe6'
  },

  secondaryColors: {
    stay: '#21a8b4',
    www: '#60df52'
  },

  borderColors: {
    stay: '#b82346',
    www: '#42a9cc'
  },

  primaryLightColors: {
    stay: '#ee597c',
    www: '#76cce8'
  },

  borderLightColors: {
    stay: '#b82346',
    www: '#89c7dc'
  },

  // iconColor
  yellow: '#f2d42b'
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/styles/colors.js
// module id = 2093
// module chunks = 0